import {useEffect} from "react";
import {useApp} from "../app.context";
import {useAccess} from "../utils/useAccess";

function SaveButton() {
    const {exportRemoteConstants} = useApp()
    const {canExportDev} = useAccess();

    useEffect(() => {
        const handleSaveShortcut = (event: any) => {
            if ((event.metaKey || event.ctrlKey) && event.key === 's') {
                event.preventDefault();
                // Ctrl/Cmd+S is a dev/test export — same gate as the button.
                // Guards the shortcut even if the component is mounted for a
                // role/branch that can't persist.
                if (!canExportDev) return;
                exportRemoteConstants(false);
            }
        };

        window.addEventListener('keydown', handleSaveShortcut);
        return () => {
            window.removeEventListener('keydown', handleSaveShortcut);
        };
    }, [exportRemoteConstants, canExportDev]);

    return (<></>)
}

export default SaveButton;